import query from 'devextreme/data/query';
import * as glb from '../globals.js';
import { ALL_PAKET_ST_TUR, ALL_SATIS_TURU_ST_TUR, getPaketStTur, getSatisTuruStTur } from './satisTipiSabit.js';

export function sabitItemsByStTur(stTur) {
  const tur = Number(stTur);
  if (!Number.isFinite(tur) || tur <= 0) return [];
  return query(glb.default.sabitLkp).filter((x) => x.ST_TUR === tur).toArray();
}

export function satisTuruItemsForCasTip(casTip) {
  return sabitItemsByStTur(getSatisTuruStTur(casTip));
}

export function satisPaketItemsForCasTip(casTip) {
  return sabitItemsByStTur(getPaketStTur(casTip));
}

export function satisTipiItems() {
  return sabitItemsByStTur(127);
}

/** Grid: satırlar farklı CAS_TIP içerebilir; ST_REF global benzersiz */
export function allSatisTuruLookupItems() {
  return query(glb.default.sabitLkp).filter((x) => ALL_SATIS_TURU_ST_TUR.includes(x.ST_TUR)).toArray();
}

export function allSatisPaketLookupItems() {
  return query(glb.default.sabitLkp).filter((x) => ALL_PAKET_ST_TUR.includes(x.ST_TUR)).toArray();
}

/** Prim parametre: her satış tipi (CAS_TIP) için satış türü seçenekleri */
export function buildPrimSatisTurleriLookup(satisTipleriRows) {
  const tips = Array.isArray(satisTipleriRows) ? satisTipleriRows : [];
  const out = [];
  const seen = new Set();
  for (const tip of tips) {
    const casTip = Number(tip.id ?? tip.ST_KODINT);
    if (!Number.isFinite(casTip) || casTip <= 0) continue;
    const stTur = getSatisTuruStTur(casTip);
    if (!stTur) continue;
    for (const row of sabitItemsByStTur(stTur)) {
      if (row.ST_SIL) continue;
      const id = Number(row.ST_REF);
      if (!Number.isFinite(id) || id <= 0) continue;
      const key = `${casTip}|${id}`;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push({ id, ad: row.ST_AD, cas_tip: casTip });
    }
  }
  return out;
}

export function mergePrimSatisTurleriLookup(serverRows, satisTipleriRows) {
  const fromSabit = buildPrimSatisTurleriLookup(satisTipleriRows);
  if (fromSabit.length > 0) return fromSabit;
  return (Array.isArray(serverRows) ? serverRows : [])
    .map((x) => ({
      id: Number(x.id),
      ad: x.ad,
      cas_tip: Number(x.cas_tip ?? x.ek),
    }))
    .filter((x) => Number.isFinite(x.id) && x.id > 0 && Number.isFinite(x.cas_tip) && x.cas_tip > 0);
}
